// extracted by mini-css-extract-plugin
export default {"loader":"Hypnosis_loader__syTF0","outer":"Hypnosis_outer__ja3tI","middle":"Hypnosis_middle__6Grfz","inner":"Hypnosis_inner__QrLjz","spin":"Hypnosis_spin__xJ5Kf"};